"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvArrayToBuffer = exports.csvArrayFromBuffer = exports.csvArrayFromBufferWithoutHeaders = exports.hiddenCharacterRegex = void 0;
const csvtojson_1 = __importDefault(require("csvtojson"));
const papaparse_1 = __importDefault(require("papaparse"));
const finley_types_1 = require("@finley-technologies/finley-types");
const csvConversion_1 = __importDefault(require("./csvConversion"));
exports.hiddenCharacterRegex = /[\u200B-\u200D\uFEFF]/g;
/**
 * Get the CSV array from a csv buffer that doesn't contain headers
 * @param csvBuffer, buffer type of csv file content
 * @returns the csv array
 */
const csvArrayFromBufferWithoutHeaders = (csvBuffer, delimiter = ',') => {
    const csvString = csvBuffer
        .toString('utf-8')
        .replace(exports.hiddenCharacterRegex, '');
    const result = csvString.split(/\r?\n/).map((row) => row.split(delimiter));
    // According to the CSV spec, the last line of a CSV may have or not have a terminating newline.
    // According to POSIX, all text files must end in a newline.
    // Detect the case where the file ends in a newline, and strip out the empty last row that results
    const lastRow = result[result.length - 1];
    if (lastRow.length === 1 && lastRow[0].length === 0) {
        result.pop();
    }
    return result;
};
exports.csvArrayFromBufferWithoutHeaders = csvArrayFromBufferWithoutHeaders;
// TODO: this is currently just a temp bandaid until we properly configure "papaparse"
// to stream and manage input appropriately. Currently, there's an issue if the "delimiter"
// is within the cell value itself
const MILLION_BASE = 1000000;
const CSV_STRING_LENGTH_LIMIT = 80 * MILLION_BASE;
/**
 * Get the CSV array from a csv buffer
 * @param csvBuffer, buffer type of csv file content
 * @returns the csv array
 */
const csvArrayFromBuffer = (csvBuffer, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const loggerFn = options === null || options === void 0 ? void 0 : options.logData;
    const csvString = csvBuffer
        .toString('utf-8')
        .replace(exports.hiddenCharacterRegex, '');
    if (loggerFn) {
        const method = csvString.length < CSV_STRING_LENGTH_LIMIT ? 'csvToJson' : 'papaparse';
        const message = `csvArrayFromBuffer: Attempting to convert csv string to array [stringLength:${csvString.length}] [method:${method}]`;
        loggerFn({ message }, finley_types_1.Log.LogLevel.Info);
    }
    // TODO: Re-enable the test 'handles mixed line endings' when removing csvToJson usage.
    if (csvString.length < CSV_STRING_LENGTH_LIMIT) {
        const csvArray = yield (0, csvtojson_1.default)({
            delimiter: (_a = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _a !== void 0 ? _a : ',',
        }).fromString(csvString);
        if (loggerFn) {
            const message = `csvArrayFromBuffer: Converted CSV string to array with [arrayLength:${csvArray.length}] [method:csvToJson]`;
            loggerFn({ message }, finley_types_1.Log.LogLevel.Info);
        }
        return csvArray;
    }
    const csvBaseParsingConfig = Object.assign(Object.assign({}, csvConversion_1.default.NEWLINE_PARSE_CONFIG), { delimiter: (_b = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _b !== void 0 ? _b : ',', quoteChar: '"', escapeChar: '"', header: true, skipEmptyLines: true });
    // For future, can convert the stream to intake the buffer directly
    // Just want to make sure the "hiddenCharacterRegex" is handled appropriately
    const csvStreamPromise = new Promise((resolve) => {
        const outputData = [];
        const outputError = [];
        papaparse_1.default.parse(csvString, Object.assign(Object.assign({}, csvBaseParsingConfig), { step(result) {
                const { data, errors } = result;
                // Currently just allowing errors to be captured for logging purposes
                // But doesn't need it to be a full stopgap to the process itself
                // Can revisit this error handling behavior if needed
                if (errors.length) {
                    for (const error of errors) {
                        outputError.push(error);
                    }
                }
                outputData.push(data);
            },
            complete() {
                resolve({ outputData, outputError });
            } }));
    });
    const { outputData, outputError } = yield csvStreamPromise;
    if (loggerFn) {
        if (outputError.length) {
            loggerFn({
                message: `Incurred ${outputError.length} errors when converting buffer to CSV array`,
                metadata: {
                    outputError: outputError.slice(0, 15),
                    truncated: outputError.length > 15,
                },
            }, finley_types_1.Log.LogLevel.Warn);
        }
        const message = `csvArrayFromBuffer: Converted CSV string to array with [arrayLength:${outputData.length}] [method:papaparse]`;
        loggerFn({ message }, finley_types_1.Log.LogLevel.Info);
    }
    return outputData;
});
exports.csvArrayFromBuffer = csvArrayFromBuffer;
/**
 * DO NOT USE THIS FOR NEW CODE
 * TODO: remove this function as it's fairly non-performant and relies on a dated JS package
 *
 * Converts csvArray to Buffer
 * @param the csv Array (array of objects)
 * @returns the csv in Buffer format
 */
const csvArrayToBuffer = (csvArray) => {
    return csvConversion_1.default.csvArrayToFinleyBuffer({
        csvArray,
        newline: '\n',
        quotes: true,
    });
};
exports.csvArrayToBuffer = csvArrayToBuffer;
//# sourceMappingURL=formatter.js.map